/**
 * @generated SignedSource<<49c3302ef3c8fb4db77945c2f5f10862>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SanitizeHtmlInput = {
  html: string;
};
export type EditorEmbedSetupModalMutation$variables = {
  input: SanitizeHtmlInput;
};
export type EditorEmbedSetupModalMutation$data = {
  readonly response: {
    readonly data: {
      readonly sanitizedHtml: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type EditorEmbedSetupModalMutation = {
  response: EditorEmbedSetupModalMutation$data;
  variables: EditorEmbedSetupModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SanitizeHtmlResponseType",
    "kind": "LinkedField",
    "name": "sanitizeHtml",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SanitizeHtmlResponse",
        "kind": "LinkedField",
        "name": "data",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sanitizedHtml",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditorEmbedSetupModalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditorEmbedSetupModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "44a109f4f4878c722ae5c3f6a05eff50",
    "id": null,
    "metadata": {},
    "name": "EditorEmbedSetupModalMutation",
    "operationKind": "mutation",
    "text": "mutation EditorEmbedSetupModalMutation(\n  $input: SanitizeHtmlInput!\n) {\n  response: sanitizeHtml(input: $input) {\n    data {\n      sanitizedHtml\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "06380a2c30eb3236e604850423c0a468";

export default node;
